{
  "version": 1,
  "asset_id": "6d76dec3-70a7-465c-a1fa-3fb37aafec8d",
  "project_id": "115256dd-a6cc-4bc1-95c1-d787d4c0e481",
  "url": "/__l5e/assets-v1/6d76dec3-70a7-465c-a1fa-3fb37aafec8d/hvac-hero.webp",
  "r2_key": "a/v1/115256dd-a6cc-4bc1-95c1-d787d4c0e481/6d76dec3-70a7-465c-a1fa-3fb37aafec8d/hvac-hero.webp",
  "original_filename": "hvac-hero.webp",
  "size": 84798,
  "content_type": "image/webp",
  "created_at": "2026-06-27T00:30:41Z"
}
